import { render, staticRenderFns } from "./ConventionObligationsDispatch.vue?vue&type=template&id=5249b1bb&scoped=true"
import script from "./ConventionObligationsDispatch.vue?vue&type=script&lang=js"
export * from "./ConventionObligationsDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5249b1bb",
  null
  
)

export default component.exports